<template>
 <div class="wrap talk re-style">
		<header>
			<h1><a href="#" class="logo"></a></h1>
		</header>
		<div class="container">
			<main class="content">
				<article class="certification">
					<section class="txt">
						<h2>PASS 본인인증</h2>
					</section>
					<section>
						<div class="box row row_c row_jsc">
							<h1>PASS 인증 완료</h1>
              <p>입금 계좌 등록을 진행 하시겠습니까?</p>
              <div class="box-notice">
                <p>■ 중고폰 : {{result.cate03Nm}}</p>
                <p>■ 접수번호 : {{result.ordNum}}</p>
                <p>■ 중고폰 판매대금 : {{ (Number(result.prodPymtAmt) + Number(result.spslAplyAmt)).toLocaleString() }} 원</p>
                <br v-if="Number(result.spslAplyAmt) > 0">
                <p v-if="Number(result.spslAplyAmt) > 0"> ■ 중고폰 평가금액 : {{ Number(result.prodPymtAmt).toLocaleString() }} 원</p>
                <p v-if="Number(result.spslAplyAmt) > 0" > ■ 추가 보상금 : <span v-for="(item, index) in result.spslAddInfos" :key="index" style="font-weight: inherit;">
                    <br v-if="index > 0">
                    <span
                      :style="index > 0
                        ? 'margin-left:10px; font-weight:inherit;'
                        : 'font-weight:inherit;'"
                    >
                      {{ item }}
                    </span>
                  </span>
                </p>
              </div>

                <!-- <p>아래 버튼을 누르고, 중고폰 판매 금액을 입금 받을</p>
                <p>계좌번호를 입력해 주세요. 알림톡 수취 후 14일 이내</p>
                <p>완료해 주셔야 정상 처리됩니다</p>
                <br> -->
                <!-- <p style="color : #929290;">·계좌 입력 후 최대 3분 내 입금됩니다</p>
                <p style="color : #929290;">·입고 후 7일 경과 또는 판매금액 입금 즉시 소유권은</p>
                <p style="color : #929290;">&nbsp;&nbsp;민팃(주)에 귀속되며 반송 불가능합니다</p> -->
						</div>
              <article class="box-bottom">
                <p class="center"><b>아래 버튼을 눌러<br>
                    판매 금액을 받을 계좌 번호를 입력해 주세요</b></p>
                <ol class="list">
                  <li class="list__item">
                    <p class="color-gray-600">계좌 입력 후 최대 3분 내 입금됩니다</p>
                  </li>
                  <li class="list__item">
                    <p class="color-gray-600">입고 후 7일 경과 또는 판매금액 입금 즉시 소유권은 민팃(주)에 귀속되며 반송 불가능합니다</p>
                  </li>
                </ol>
              </article>
					</section>
					<div class="btn-wrap">
						<a href="javascript:void(0);" class="talk-btn btn-black" @click.stop.prevent="talkDeposit()">계좌번호 입력하기</a>
					</div>
				</article>
			</main>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import AppConfig from '@/config'


export default {
  name: 'CrtfPassSuc5',
  components: {

   },
  data: () => ({
    AppConfig: AppConfig,
    isProc: false,
    result:{}
  }),
  computed: {
    getOrderNumber () {
      return this.$route.query.ordNum
    }
  },
  mounted() {
    this.certPassData();
  },
  methods: {
    async certPassData () {

      const vm = this;
      const params = {ordNum : this.getOrderNumber}
      const rtn = await Vue.httpClient
        .get('/api/purchase/pcs/mgmt/public/ord-num' , {params} )
        .then(res => {
          if (res.data.status === AppConfig.HTTP_RESPONSE_SUCCESS) {
            if (res.data.result)
              console.log(res.data.result)
              this.result = res.data.result;

          } else {
            Vue.Alert.alert("통신 오류 입니다.")
          }

        })
    },
    talkDeposit() {
    	this.$router.push({name: 'TalkDepositNew', query: {ord_number: this.getOrderNumber}})
    }
    
  }
}
</script>

<style>
.re-style .certification section .box .box-notice{
max-width:100% !important;
}
</style>




// WEBPACK FOOTER //
// src/views/crtfpass/CrtfPassSuc5.vue